import * as React from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, ButtonTheme } from '../../enums';
import { highlightTextFragments, toMarkdown } from '../../utils';
import { Button } from '../button/button.component';

import { Container, ImageElement, ImageContainer, TextContainer, Title } from './bigPhotoBox.styled';
import { BigPhotoBoxProps } from './bigPhotoBox.types';

export const BigPhotoBox: React.FC<BigPhotoBoxProps> = (props: BigPhotoBoxProps): JSX.Element => {
  const { title, image, buttonLabel, buttonAction, className }: BigPhotoBoxProps = props;
  const isMobile: boolean = useMediaQuery({ query: Breakpoint.Mobile });
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });

  return (
    <Container className={className}>
      <ImageContainer>
        <ImageElement src={image} alt={title} />
      </ImageContainer>
      <TextContainer>
        <Title
          dangerouslySetInnerHTML={{
            __html: toMarkdown(highlightTextFragments(title))
          }} 
          data-testid='title-big-photo-box'
        />
        <Button 
          label={buttonLabel} 
          onClick={buttonAction} 
          fullWidth={isMobile} 
          buttonTheme={isSmallMobile ? ButtonTheme.PrimarySmall : ButtonTheme.PrimaryBig} 
        />
      </TextContainer>
    </Container>
  );
};
